import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'cpq-setup-cpq-iframe-dialog',
    templateUrl: './cpq-iframe-dialog.component.html',
    styleUrls: ['./cpq-iframe-dialog.component.scss'],
    standalone: false
})
export class CpqIframeDialogComponent implements OnInit {
  public src: SafeResourceUrl;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<CpqIframeDialogComponent>) { }


  ngOnInit() {
    this.src = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.src);
  }

  close() {
    this.dialogRef.close(false);
  }

}
